import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Clock, Globe, MapPin, AlertTriangle } from 'lucide-react';

export const ShippingPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="shipping-policy-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="shipping-title">Shipping Policy</h1>
          <p className="text-lg text-softgrey">We are committed to delivering your order in a timely and secure manner.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-cream p-8 rounded-xl" data-testid="processing-time-section">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Processing Time</h2>
            </div>
            <p className="text-softgrey leading-relaxed">All orders are processed within <strong>1-2 working days</strong> (excluding weekends and public holidays).</p>
          </section>

          <section data-testid="uk-delivery-section">
            <div className="flex items-center gap-3 mb-4">
              <Truck className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">UK Delivery</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>Estimated delivery time: <strong>3-5 working days</strong></li>
              <li>Fully tracked delivery</li>
            </ul>
          </section>

          <section data-testid="international-delivery-section">
            <div className="flex items-center gap-3 mb-4">
              <Globe className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">EU & International Delivery</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>Delivery time: <strong>5-10 working days</strong></li>
              <li>Customers responsible for customs duties and VAT</li>
            </ul>
          </section>

          <section data-testid="delivery-responsibility-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Delivery Responsibility</h2>
            <p className="text-softgrey leading-relaxed">We are responsible until delivery is completed.</p>
          </section>

          <section data-testid="delays-section">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Delays</h2>
            </div>
            <p className="text-softgrey leading-relaxed">May occur due to courier or customs issues.</p>
          </section>

          <section data-testid="incorrect-address-section">
            <div className="flex items-center gap-3 mb-4">
              <MapPin className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Incorrect Address</h2>
            </div>
            <p className="text-softgrey leading-relaxed">Customer must ensure correct address. We are not responsible for delays or failed deliveries caused by incorrect address information.</p>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Have questions about shipping? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> or visit our <Link to="/faq" className="text-coral hover:underline font-semibold">FAQ</Link>.</p>
        </div>
      </div>
    </div>
  );
};
